import QRCode from "qrcode";

export const qrDataUrl = (url, width = 600) => QRCode.toDataURL(url, { width, margin: 2, errorCorrectionLevel: "M" });

export async function downloadQr(url, name) {
  const a = document.createElement("a");
  a.href = await qrDataUrl(url, 1024);
  a.download = `${name}.png`;
  document.body.appendChild(a);
  a.click();
  a.remove();
}

export async function copyText(text) {
  try {
    await navigator.clipboard.writeText(text);
  } catch {
    const ta = document.createElement("textarea");
    ta.value = text;
    document.body.appendChild(ta);
    ta.select();
    document.execCommand("copy");
    ta.remove();
  }
}

const esc = (s = "") => String(s).replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));

export async function printPoster({ store, title, subtitle, url, color, logo }) {
  const c = /^#[0-9a-f]{3,8}$/i.test(color || "") ? color : "#2563eb";
  const qr = await qrDataUrl(url, 900);
  const f = document.createElement("iframe");
  f.style.cssText = "position:fixed;right:0;bottom:0;width:0;height:0;border:0";
  document.body.appendChild(f);
  const d = f.contentWindow.document;
  d.open();
  d.write(`<!doctype html><html><head><meta charset="utf-8"><title>${esc(title)}</title><style>
@page{size:A4;margin:0}*{box-sizing:border-box}
body{margin:0;font-family:Arial,Helvetica,sans-serif;color:#0f172a;-webkit-print-color-adjust:exact;print-color-adjust:exact}
.p{width:210mm;height:296mm;display:flex;flex-direction:column;align-items:center;text-align:center}
.b{width:100%;height:14mm;background:${c}}.f{margin-top:auto;width:100%;height:10mm;background:${c}}
.logo{margin-top:14mm;height:28mm;max-width:80mm;object-fit:contain}
h1{font-size:32pt;margin:10mm 18mm 0}h2{font-size:24pt;margin:6mm 18mm 0;color:${c}}.s{font-size:14pt;margin:3mm 18mm 0;color:#475569}
.qr{margin-top:10mm;width:118mm;height:118mm;border:3mm solid ${c};border-radius:6mm;padding:2mm}
.h{font-size:14pt;margin:8mm 18mm 0;font-weight:bold}.u{font-size:10pt;color:#64748b;margin:3mm 18mm 0;word-break:break-all}
</style></head><body><div class="p"><div class="b"></div>${logo ? `<img class="logo" src="${esc(logo)}">` : ""}
<h1>${esc(store)}</h1><h2>${esc(title)}</h2>${subtitle ? `<p class="s">${esc(subtitle)}</p>` : ""}
<img class="qr" src="${qr}"><p class="h">Aponte a câmera do celular para o QR Code</p><p class="u">${esc(url)}</p><div class="f"></div></div></body></html>`);
  d.close();
  await Promise.all([...d.images].map((im) => (im.complete ? null : new Promise((r) => { im.onload = r; im.onerror = r; }))));
  f.contentWindow.focus();
  f.contentWindow.print();
  setTimeout(() => f.remove(), 1500);
}
